import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { composeDecoratedDetailSearchFilter } from 'utils/insightModal/composeDecoratedDetailSearchFilter'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'
import { composeDecoratedDrillDownWidgetSetting } from 'utils/insightModal/composeDecoratedDrillDownWidgetSetting'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { DecoratedSearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/decorator/type'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { DecoratedWidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/decorator/type'
import { InsightContentSettingType } from 'components/insightContent/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import AnalysisFilter from 'types/analysisFilter'
import { toFilter } from '../../../../../utils/widgetUtil'
import { SideBySideWidgetsType, InsightObjective } from '../../types'

const resolvePivot = (selection: InsightObjective) => {
  const { themeId, tagName, docName } = selection
  if (themeId !== undefined) {
    return { id: themeId.toString() } as InsightData
  }
  if (tagName !== undefined) {
    return { name: tagName } as InsightData
  }
  if (docName !== undefined) {
    return { name: docName } as InsightData
  }

  return undefined
}

const resolveSelectedTopic = (
  widgetSetting: SideBySideWidgetsType,
  selection: InsightObjective
) => {
  const { topicInfos, selectedTopic } = widgetSetting
  const { topicId } = selection

  return topicInfos?.find((topicInfo) => topicInfo.topicId === topicId) || selectedTopic
}

export const convertToInsightContentSetting = (
  widgetSetting: SideBySideWidgetsType,
  strategy: SearchFilterComposingStrategy | DecoratedSearchFilterComposingStrategy,
  selection?: Array<InsightObjective>
) => {
  const { viewOption } = widgetSetting

  const insightContentSetting = ({
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos:
      selection && selection.length > 0 ? selection?.[0].topicId : widgetSetting.topicInfos!,
    drillDownTypes: [''],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic.topicId!
  } as unknown) as InsightContentSettingType
  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  if (selection && selection.length > 0) {
    const { name, topicId } = selection[0]
    insightContentSetting.selectionName = name
    insightContentSetting.topicId = topicId

    const insights = selection.map((item) => item.insight)
    const pivot = resolvePivot(selection[0])

    if (pivot) {
      insightContentSetting.filter = composeDecoratedDetailSearchFilter(
        strategy as DecoratedSearchFilterComposingStrategy,
        widgetSetting,
        [],
        [pivot]
      )
      insightContentSetting.selectionFilter = composeDecoratedDetailSearchFilter(
        strategy as DecoratedSearchFilterComposingStrategy,
        widgetSetting,
        insights,
        [pivot]
      )
    } else {
      insightContentSetting.selectionFilter = composeDetailSearchFilter(
        strategy as SearchFilterComposingStrategy,
        widgetSetting,
        insights
      )
    }
  }

  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: SideBySideWidgetsType,
  applicationSettings: any,
  strategy: WidgetSettingComposingStrategy | DecoratedWidgetSettingComposingStrategy,
  selection?: Array<InsightObjective>
) => {
  if (!widgetSetting || typeof widgetSetting !== 'object') {
    return {}
  }

  if (!selection || selection.length === 0) {
    return {}
  }

  const insights: InsightData[] = selection.map((item) => item.insight)
  const pivot = resolvePivot(selection[0])
  const selectedTopic = resolveSelectedTopic(widgetSetting, selection[0])

  if (pivot) {
    const drillDownWidgetSetting = composeDecoratedDrillDownWidgetSetting(
      strategy,
      widgetSetting,
      insights,
      [pivot]
    )
    drillDownWidgetSetting.selectedTopic = selectedTopic
    return drillDownWidgetSetting
  }

  const drillDownWidgetSetting = composeDrillDownWidgetSetting(
    strategy as WidgetSettingComposingStrategy,
    widgetSetting,
    insights
  )
  drillDownWidgetSetting.selectedTopic = selectedTopic
  return drillDownWidgetSetting
}
